var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBxLayer = function SvgBxLayer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m.688 7.19 6.079 4.27c.285.2.623.304.976.304.354 0 .691-.105.98-.306L14.8 7.19c.43-.304.687-.793.687-1.31 0-.518-.257-1.007-.689-1.312L8.72.298a1.75 1.75 0 0 0-1.957.003L.687 4.569C.257 4.873 0 5.362 0 5.88c0 .518.257 1.007.688 1.311m7.059-5.578L13.82 5.88l-6.07 4.265-.008.001-.003.002L1.665 5.88z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.85 10.109-6.112 4.27-6.025-4.213-1.411 1.009 6.465 4.52a1.71 1.71 0 0 0 1.955-.001l6.56-4.587z"
  })));
};
export default SvgBxLayer;